export const TITLE_OPTIONS = [
  { value: "MR", label: "Mr." },
  { value: "MRS", label: "Mrs." },
  { value: "MS", label: "Ms." },
  { value: "MISS", label: "Miss" },
  { value: "Master", label: "Master" },
  { value: "Mx", label: "Mx" },
  { value: "DR", label: "Dr." },
  { value: "PROF", label: "Prof." },
  { value: "Rev", label: "Rev." },
  { value: "Sir", label: "Sir" },
  { value: "Lord", label: "Lord" },
  { value: "Lady", label: "Lady" },
];

export const GENDER_OPTIONS = [
  { value: "UNDEF", label: "Undisclosed" },
  { value: "FEMALE", label: "Female" },
  { value: "MALE", label: "Male" },
  { value: "NON_BINARY", label: "Unspecified/Others" },
];

export const LANGUAGE_OPTIONS = [
  { value: "cs_CZ", label: "Czech (Czechia)" },
  { value: "da_DK", label: "Danish (Denmark)" },
  { value: "nl_BE", label: "Dutch (Belgium)" },
  { value: "nl_NL", label: "Dutch (Netherlands)" },
  { value: "en_GB", label: "English (United Kingdom)" },
  { value: "en_US", label: "English (United States)" },
  { value: "fr_BE", label: "French (Belgium)" },
  { value: "fr_FR", label: "French (France)" },
  { value: "fr_CH", label: "French (Switzerland)" },
  { value: "de_AT", label: "German (Austria)" },
  { value: "de_DE", label: "German (Germany)" },
  { value: "de_CH", label: "German (Switzerland)" },
  { value: "hu_HU", label: "Hungarian (Hungary)" },
  { value: "it_IT", label: "Italian (Italy)" },
  { value: "it_CH", label: "Italian (Switzerland)" },
  { value: "kl_GL", label: "Kalaallisut (Greenland)" },
  { value: "no_NO", label: "Norwegian (Norway)" },
  { value: "pl_PL", label: "Polish (Poland)" },
  { value: "pt_PT", label: "Portuguese (Portugal)" },
  { value: "sk_SK", label: "Slovak (Slovakia)" },
  { value: "es_ES", label: "Spanish (Spain)" },
  { value: "sv_SE", label: "Swedish (Sweden)" },
];

export const EMPTY_PASSPORT = { country: "", number: "", issueDate: "", issuePlace: "", issueCountry: "", expiration: "", primary: false };
export const EMPTY_VISA = { country: "", number: "", issueDate: "", expiration: "", entryType: "", linkedPassport: "" };
export const EMPTY_IDCARD = { country: "", number: "", issueDate: "", expiration: "" };
export const EMPTY_FLIGHT = { alliance: "", memberNumber: "", pin: "" };
export const EMPTY_HOTEL = { alliance: "", memberNumber: "", customerRequest: "" };
export const EMPTY_CAR = { alliance: "", memberNumber: "", customerRequest: "", specialRequest: "" };
export const EMPTY_PAYMENT = { type: "", number: "", expiration: "", remark: "", nameOnCard: "" };

export const CARD_TYPE_OPTIONS = [
  { value: "TP", label: "AirPlus" },
  { value: "AX", label: "American Express" },
  { value: "DC", label: "Diners" },
  { value: "DS", label: "Discover" },
  { value: "CA", label: "Mastercard / Eurocard" },
  { value: "VI", label: "Visa" },
];

export const carSpecialRequestOptions = [
  { value: "AIR", label: "Air Conditioning" },
  { value: "ABS", label: "Anti Blocking System" },
  { value: "ATD", label: "Anti Theft Device" },
  { value: "BYC", label: "Bicycle Rack" },
  { value: "CAM", label: "Camcorder" },
  { value: "CAL", label: "Car Alarm" },
  { value: "TEL", label: "Car Telephone" },
  { value: "TAP", label: "Cassette Tape" },
  { value: "CLS", label: "Central Locking System" },
  { value: "CSB", label: "Child Seat for Baby" },
  { value: "CSI", label: "Child Seat for Infant" },
  { value: "CST", label: "Child Seat for Toddler" },
  { value: "CBR", label: "Citizens Band Radio" },
  { value: "CCD", label: "Computerized Driving Direct" },
  { value: "DAB", label: "Driver Side Airbag" },
  { value: "FMR", label: "FM Radio" },
  { value: "FRT", label: "Front Wheel Drive" },
  { value: "HCL", label: "Hand Controls on Left" },
  { value: "HCR", label: "Hand Controls on Right" },
  { value: "HCH", label: "Hatchback Car" },
  { value: "ICS", label: "Integrated Child Safety Seat" },
  { value: "LDP", label: "Laserdisc Player" },
  { value: "LFF", label: "Lead Free Fuel" },
  { value: "LFA", label: "Left Foot Accelerator" },
  { value: "PHN", label: "Mobile Phone" },
  { value: "NVS", label: "Navigational System" },
  { value: "NVP", label: "Navigational System Plus Phone" },
  { value: "NSK", label: "Non Smoker Car" },
  { value: "PAX", label: "Number of Passengers" },
  { value: "PAB", label: "Passenger Side Airbag" },
  { value: "PAS", label: "Power Assisted Steering" },
  { value: "PDL", label: "Power Door Locks" },
  { value: "PWS", label: "Power Windows" },
  { value: "RAD", label: "Radio" },
  { value: "RSB", label: "Rear Seat Belts" },
  { value: "SBE", label: "Seat Belt Extenders" },
  { value: "SIX", label: "Six Passenger Car" },
  { value: "SKV", label: "Ski Equipped Vehicle" },
  { value: "SKR", label: "Ski Rack" },
  { value: "SKI", label: "Ski Rental" },
  { value: "SNO", label: "Snow Chains" },
  { value: "SUR", label: "Sun Roof" },
  { value: "TVI", label: "Television" },
  { value: "TSW", label: "Tilt Steering Wheel" },
  { value: "TRH", label: "Trailer Hitch" },
  { value: "STR", label: "Winter Tyres" },
];

export const INITIAL_STATE = {
  uuid: "",
  username: "",
  firstname: "",
  middlename: "",
  name: "",
  companyUuid: "",
  birthdate: "",
  sex: "",
  mobilePhone: "",
  nationality: "",
  language: "en_GB",
  privatePhone: "",
  businessPhone: "",
  title: "",
  email: "",
  emgFirstname: "",
  emgLastname: "",
  emgPhone: "",
  emgEmail: "",
  preferences: {
    seatRequest: "",
    mealRequest: "",
    smoker: false,
  },
  memberships: {
    flight: [],
    hotel: [],
    rentalCar: [],
  },
  papers: {
    passports: [],
    visas: [],
    idCards: [],
  },
  payments: [],
  customFields: {},
};

export const getPersonalFields = ({ companies = [], countries = [], user }) => [
  { name: "username", label: "Username", required: true, col: "md:col-span-12 lg:col-span-6", disabled: !!user?.email },
  { name: "title", label: "Title", type: "select", options: TITLE_OPTIONS, col: "md:col-span-6 lg:col-span-6" },
  { name: "firstname", label: "First name as in Passport", required: true, col: "md:col-span-4" },
  { name: "middlename", label: "Middle name as in Passport", col: "md:col-span-4" },
  { name: "name", label: "Surname as in Passport", required: true, col: "md:col-span-4" },
  { name: "sex", label: "Gender", type: "select", options: GENDER_OPTIONS, required: true, col: "md:col-span-6 lg:col-span-4" },
  { name: "birthdate", label: "Date of Birth", type: "date", maxDate: "today", required: true, col: "md:col-span-4" },
  { name: "nationality", label: "Citizenship", type: "select", options: countries, placeholder: "e.g. CH", required: true, col: "md:col-span-4" },
  { name: "language", label: "Language", type: "select", options: LANGUAGE_OPTIONS, required: true, col: "md:col-span-4" },
  { name: "email", label: "E-mail", type: "email", required: true, col: "md:col-span-12 lg:col-span-8" },
  { name: "mobilePhone", label: "Mobile", type: "tel", col: "md:col-span-12 lg:col-span-4" },
  { name: "businessPhone", label: "Phone Business", type: "tel", col: "md:col-span-12 lg:col-span-4" },
  { name: "privatePhone", label: "Phone Private", type: "tel", col: "md:col-span-12 lg:col-span-4" },
];

export const getEmergencyFields = () => [
  { name: "emgFirstname", label: "First Name", col: "md:col-span-6" },
  { name: "emgLastname", label: "Last Name", col: "md:col-span-6" },
  { name: "emgEmail", label: "Email", type: "email", col: "md:col-span-6" },
  { name: "emgPhone", label: "Phone", type: "tel", col: "md:col-span-6" },
];

export const parseDateFromAPI = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "";
  const trimmed = dateStr.trim();
  if (trimmed.includes("-")) {
    const cleanDate = trimmed.split("T")[0];
    const parts = cleanDate.split("-");
    return parts.length === 3 ? `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}` : cleanDate;
  }
  const parts = trimmed.split(".");
  return parts.length === 3 ? `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}` : "";
};

export const formatDateToAPI = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "";
  const trimmed = dateStr.trim();
  if (trimmed.includes(".")) return trimmed;
  const cleanDate = trimmed.split("T")[0];
  const parts = cleanDate.split("-");
  return parts.length === 3 ? `${parts[2].padStart(2, "0")}.${parts[1].padStart(2, "0")}.${parts[0]}` : trimmed;
};

export const SectionHeader = ({ title, icon, theme = "primary" }) => {
  const themes = {
    primary: { bg: "bg-[#2D0B31]/10", text: "text-[#2D0B31]" },
    danger: { bg: "bg-red-600/10", text: "text-red-600" },
  };

  return (
    <div className="mb-6 mt-10 flex items-center gap-3 border-b border-gray-100 pb-4 first:mt-0">
      <div className={`flex h-8 w-8 items-center justify-center rounded-lg ${themes[theme].bg} ${themes[theme].text}`}>{icon}</div>
      <h3 className="text-lg font-bold text-gray-900">{title}</h3>
    </div>
  );
};
